export interface RuntimeConfig {
  /** URL base de la API. Vacío = mismo origen (proxy inverso delante del panel y la API). */
  apiUrl: string;
}

let current: RuntimeConfig = { apiUrl: '' };

/**
 * La configuración se lee en tiempo de ejecución de `/config.json`, de modo que el mismo build
 * sirve para cualquier entorno/proveedor: solo cambia ese fichero (o la variable API_URL del
 * contenedor nginx, que lo genera al arrancar).
 */
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) {
      const json = (await res.json()) as Partial<RuntimeConfig>;
      current = { apiUrl: (json.apiUrl ?? '').replace(/\/$/, '') };
    }
  } catch {
    /* sin config.json → mismo origen */
  }
  if (!current.apiUrl && import.meta.env.VITE_API_URL) current.apiUrl = String(import.meta.env.VITE_API_URL).replace(/\/$/, '');
  return current;
}

export const runtimeConfig = () => current;
